<template>
  <div>
    <b-table striped small fixed responsive="sm" caption-top :items="items" :fields="fields">
      <template slot="table-caption">{{user? user.email: 'INVALID USER'}} ({{user? user.displayName: id }})</template>
      <template slot="value" slot-scope="data">
        <strong>{{data.item.value | beautify}}</strong>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: 'User',
  props: {
    id: {
      type: String
    },
    caption: {
      type: String,
      default: 'User id'
    },
  },
  data: function() {
    return {
      user: null,
      fields: [
        {key: 'key'},
        {key: 'value'},
      ],
    }
  },
  created: function() {
    console.debug('created : ', this.id)
    if (!this.id) {
      console.error("id required")
      return
    }

    const uid = this.id.split('/').filter( s => !!s).pop() //get last element
    console.info('uid: ', uid)
    this.$bind('user', this.$firebase.firestore().collection('users').doc(uid))
  },  
  computed: {
    items() {
      const userDetails = this.user ? Object.entries(this.user) : [['id', 'Not found']]
      return userDetails.filter(([key, value]) => {
        return key !== 'hasDevices'
      })
      .map(([key, value]) => {
        const newValue = (key === 'groupTo' && value && value.name ? value.name: value)
        return {key: key, value: newValue}
      })
      .filter( (item, index, items) => {
        return !['passwordHash', 'encryptKey'].includes(item.key)
      })
    },
  },
  mounted: function() {

  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
